import 'css-chunksrc/client/pages/projectPage/resourcesPage/sidebar/styles.scss';export default {
  "sidebar": "_sidebar_1ktr5_1",
  "header": "_header_1ktr5_5",
  "icon": "_icon_1ktr5_12",
  "title": "_title_1ktr5_18",
  "groups": "_groups_1ktr5_25",
  "group": "_group_1ktr5_25",
  "groupName": "_groupName_1ktr5_40",
  "groupIcon": "_groupIcon_1ktr5_48",
  "groupPlaceholder": "_groupPlaceholder_1ktr5_53",
  "name": "_name_1ktr5_74",
  "groupResources": "_groupResources_1ktr5_79",
  "iconResource": "_iconResource_1ktr5_94",
  "selectedResource": "_selectedResource_1ktr5_99",
  "notSelectedResource": "_notSelectedResource_1ktr5_104",
  "avatar": "_avatar_1ktr5_109",
  "rolesFilter": "_rolesFilter_1ktr5_119",
  "loader": "_loader_1ktr5_123",
  "groupSkeleton": "_groupSkeleton_1ktr5_131",
  "itemLoader": "_itemLoader_1ktr5_137",
  "iconSkeleton": "_iconSkeleton_1ktr5_144"
};